import React, { useState , useEffect , useRef} from 'react';
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import BusinessesCard from './BusinessesCard';
import RegisterBusinessCard from './RegisterBusinessCard';
import RequestsCard from './RequestsCard';
import { useTranslation } from 'react-i18next';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { jwtDecode } from 'jwt-decode';
import EditAmenityProvider from './EditAmenityProvider'

const Container = styled.div`
  margin-bottom: 100px;
  width: 100%;
  padding: 50px;

  h1 {
    font-size: 40px;
    display: flex;
    color: #385963;
    font-weight: 600;
    justify-content: center;
    margin-bottom: 30px;
  }

   @media (max-width: 768px) {
   h1{text-align:center;
   font-size:18px;
   
}
     padding: 20px;
  }
`;

const columnStyle = css`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const SectionHeader = styled.div`
  background: #f2f6f7;
  color: #385963;
  font-size: 20px;
  font-weight: 600;
  padding: 15px 20px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  
  @media (max-width: 768px) {
   font-size:14px;
  }

`;

const SectionContent = styled.div`
  padding: 20px 0;
`;

const BusinessProviderControl = () => {
  const { i18n } = useTranslation();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const tokenString = sessionStorage.getItem("token");
  const [openSection, setOpenSection] = useState(null);
  const [amenities, setAmenities] = useState([]);
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const decodedToken = jwtDecode(decodeURIComponent(tokenString));
  const userId = decodedToken.sub;
  const userName = decodedToken.name;
  const email = decodedToken.unique_name;
  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };
  const [view, setView] = useState('main'); 
const [selectedAmenity, setSelectedAmenity] = useState(null); 

useEffect(() => {
  const fetchAmenities = async () => {
    try {
      const fetchByStatus = async (status) => {
        const requestBody = {
          categoryId: null,
          providerId: userId,
          status: status,
          model: {}
        };

        const response = await fetch(`${BASE_URL}Amenity/search`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${tokenString}`
          },
          body: JSON.stringify(requestBody)
        });

        return await response.json();
      };

      const [pending, forRevision] = await Promise.all([
        fetchByStatus(0),
        fetchByStatus(3),
      ]);

      const allAmenities = [...pending, ...forRevision];
      setAmenities(allAmenities);
    } catch (error) {
      console.error('Error fetching amenities:', error);
    }
  };

  fetchAmenities();
}, []);


return (
  <Container>
    <h1>{i18n.t('manageAmenities')}</h1>

    {view === 'main' && (
      <div css={columnStyle}>
        {/* All your sections go here */}
        <div>
          <SectionHeader onClick={() => toggleSection('businesses')}>
            {i18n.t('amenities')}
            {openSection === 'businesses' ? <FaChevronUp /> : <FaChevronDown />}
          </SectionHeader>
          {openSection === 'businesses' && (
            <SectionContent>
              <BusinessesCard
                onEditAmenity={(amenity) => {
                  setSelectedAmenity(amenity);  // store the amenity
                  setView('edit');              // switch to edit screen
                }}
              />
            </SectionContent>
          )}
        </div>
       {/* Register Business */}
       <div>
         <SectionHeader onClick={() => toggleSection('register')}>
           {i18n.t('addAmenity')}
           {openSection === 'register' ? <FaChevronUp /> : <FaChevronDown />}
         </SectionHeader>
         {openSection === 'register' && (
           <SectionContent>
             <RegisterBusinessCard />
           </SectionContent>
         )}
       </div>
  
       {/* Requests */}
       <div>
         <SectionHeader onClick={() => toggleSection('requests')}>
           {i18n.t('requests')}
           {openSection === 'requests' ? <FaChevronUp /> : <FaChevronDown />}
         </SectionHeader>
         {openSection === 'requests' && (
           <SectionContent>

            <RequestsCard
              amenitiesReq={amenities}
              onEditAmenity={(amenity) => {
                setSelectedAmenity(amenity);
                setView('edit');
              }}
            />
           </SectionContent>
         )}
       </div>
      </div>
    )}

    {view === 'edit' && selectedAmenity && (
      <EditAmenityProvider
        amenity={selectedAmenity}
        onBack={() => setView('main')} // when "Back" is clicked
      />
    )}
  </Container>
);

};

export default BusinessProviderControl;
